<template>
  <div class="el-popper capital-dropdown" :style="{ width: '220px' }">
    <div  @click="onSelect('0')" :class="check(0) ? 'capital-item selected' : 'capital-item'" class="all">全部</div>
    <span @click="onSelect('#dfe2e5')" style="background-color:#dfe2e5;margin-left: 22px;" :class="check('#dfe2e5') ? 'selected' : ''"></span>
    <span @click="onSelect('#F9B522')" style="background-color:#F9B522" :class="check('#F9B522') ? 'selected' : ''"></span>
    <span @click="onSelect('#F9665A')" style="background-color:#F9665A" :class="check('#F9665A') ? 'selected' : ''"></span>
    <span @click="onSelect('#87C965')" style="background-color:#87C965" :class="check('#87C965') ? 'selected' : ''"></span>
    <span @click="onSelect('#606DDD')" style="background-color:#606DDD" :class="check('#606DDD') ? 'selected' : ''"></span>
    <span @click="onSelect('#64C9D9')" style="background-color:#64C9D9" :class="check('#64C9D9') ? 'selected' : ''"></span>
  </div>
</template>

<script>
  export default {
    props: ['value'],
    inject: ['select'],
    data() {
      return {
        minWidth: '',
      };
    },
    methods: {
      onSelect(val) {
        this.$emit('input', val);
        this.select.visible = false;
      },
      check(val) {
        if (this.value == val) {
          return true;
        }
      }
    },
  };
</script>
<style lang="scss" scoped>
  .capital-dropdown {
    border-radius: 4px;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    span{
      height: 18px;
      width: 18px;
      border-radius: 3px;
      margin:5px 3px 13px;
      display: inline-block;
      cursor: pointer;
    }
    span.selected{
      background: url('../../assets/images/tabList/colorChoose.png') no-repeat 2px center;
    }
    span:hover{
      -webkit-transform:scale(1.1) ;
      -moz-transform:scale(1.1)  ;
      -ms-transform: scale(1.1) ;
      -o-transform: scale(1.1) ;
      transform:scale(1.1) ;
    }
  }
  .capital-item {
    font-size: 14px;
    padding: 0 20px;
    position: relative;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #5a5e66;
    height: 34px;
    line-height: 34px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    cursor: pointer;
    margin-top: 5px;
  }
  .capital-item.selected {
    color: var(--theme-color);
  }
  .capital-item.hover,
  .capital-item:hover {
    background: #f5f7fa;
  }
</style>




// WEBPACK FOOTER //
// src/components/clickSelect/colorChoose.vue